import { FC } from 'react'

import { CryptoRewardsPanePreset } from 'components/features/rewards/rewardsPane/components/CryptoRewardsPanePreset/CryptoRewardsPanePreset'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { getCryptoRewardsPaneProgressPercentsStateSelector } from 'components/features/rewards/rewardsPane/store/selectors/paneState'

type CryptoRewardsBuySendingOrderStepProps = {
  onClose: () => void
}

export const CryptoRewardsBuySendingOrderStep: FC<CryptoRewardsBuySendingOrderStepProps> = ({ onClose }) => {
  const paneProgressPercent = useStoreSelector(getCryptoRewardsPaneProgressPercentsStateSelector)

  return (
    <CryptoRewardsPanePreset
      title='Invest Your Rewards Into Crypto'
      subTitle=''
      onCancel={ onClose }
      progressBarPercent={ paneProgressPercent }
    >
      <LoadingOverlay />
    </CryptoRewardsPanePreset>
  )
}
